<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-container">
    <!-- :style="{
      background: configurationData.colorTheme
        ? configurationData.colorTheme
        : '#fff',
    }" -->
    <div class="sidebar-brand">
      <router-link
        v-if="roles == 'user' || roles == 'admin'"
        to="/index"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          :src="
            configurationData.logoUrl
              ? url + configurationData.logoUrl
              : '/logo.png'
          "
          alt=""
          class="logo"
        />
      </router-link>
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          v-if="roles != 'user' && roles != 'admin'"
          :src="
            configurationData.logoUrl
              ? url + configurationData.logoUrl
              : '/logo.png'
          "
          alt=""
          class="logo"
        />
      </div>
    </div>
    <el-scrollbar class="menu-scrollbar" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        text-color="#333"
        :unique-opened="true"
        :active-text-color="'#FF830E'"
        :collapse-transition="false"
        :mode="
          configurationData &&
          configurationData.menuConfig != '' &&
          configurationData.menuConfig != null &&
          configurationData.menuConfig != undefined
            ? configurationData.menuConfig
            : 'vertical'
        "
        :background-color="
          configurationData && configurationData.colorTheme
            ? configurationData.colorTheme
            : '#fff'
        "
      >
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script setup>
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.module.scss";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";
import useBusinessTodoStore from "@/store/modules/businessTodo";

const url = ref(import.meta.env.VITE_APP_BASE_API + "/file/download/?fileId=");
const props = defineProps({
  configurationData: Object,
});

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();
const businessTodoStore = useBusinessTodoStore();
const roles = sessionStorage.getItem(`roles`) ? JSON.parse(sessionStorage.getItem(`roles`))[0] : '';

const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const showLogo = computed(() => settingsStore.sidebarLogo);
const sideTheme = computed(() => settingsStore.sideTheme);
const theme = computed(() => settingsStore.theme);
const isCollapse = computed(() => !appStore.sidebar.opened);

// 获取菜单背景色
const getMenuBackground = computed(() => {
  if (settingsStore.isDark) {
    return "var(--sidebar-bg)";
  }
  return sideTheme.value === "theme-dark"
    ? variables.menuBg
    : variables.menuLightBg;
});

// 获取菜单文字颜色
const getMenuTextColor = computed(() => {
  if (settingsStore.isDark) {
    return "var(--sidebar-text)";
  }
  return sideTheme.value === "theme-dark"
    ? variables.menuText
    : variables.menuLightText;
});

const activeMenu = computed(() => {
  const { meta, path } = route;
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
});

onMounted(() => {
  businessTodoStore.refresh();
});

watch(
  () => route.fullPath,
  () => {
    businessTodoStore.refresh(true);
  }
);
</script>

<style lang="scss" scoped>
.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100vh !important;
  min-height: 0;
  overflow: hidden;
  background-color: #fff;

  .sidebar-brand {
    flex: 0 0 auto;
    width: 100%;
  }

  :deep(.menu-scrollbar) {
    flex: 1 1 0;
    min-height: 0;
    height: 0 !important;
  }

  :deep(.menu-scrollbar .el-scrollbar__wrap) {
    overflow-x: hidden;
  }

  .scrollbar-wrapper {
    background-color: #fff;
  }

  .logo {
    width: 6.238184928894043rem;
    height: 2.0625rem;
    // margin-left: 2.5rem;
    margin-top: 1.3125rem;
    margin-bottom: 1.375rem;
  }

  ::v-deep .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
    background: #fff;

    .el-menu-item {
      color: #000;
      background: #fff;
      &.is-active {
        color: #fff !important;
        background: #ff830e !important;
      }
      &.is-active:hover {
        background: #ff830e !important;
      }
    }

    .el-sub-menu__title {
      background: #fff;
    }
  }
}
#app .sidebar-container {
  width: 15rem !important;
  border: 1px solid #f3f3f3;
  background: #fff;
  -webkit-box-shadow: none !important;
}
#app .sidebar-container .el-menu-item,
#app .sidebar-container .menu-title {
  color: #000;
}
::v-deep.el-menu-item.is-active {
  color: #fff !important;
  background: #ff830e !important;
}
</style>
